import { Banner, BannerItem } from '@athena/forge';
import { INFO_BANNER_MESSAGE_KEY_MAP_V2 } from '../../constants';
import { getLocalizedString } from '../../utils/i18n-utils';
export default function UserLockedOutBanner() {
  const HEADER_TEXT = getLocalizedString(INFO_BANNER_MESSAGE_KEY_MAP_V2['ERROR']['ACCOUNTBLOCKED'].header);
  const HEADER_DESCRIPTION = getLocalizedString(INFO_BANNER_MESSAGE_KEY_MAP_V2['ERROR']['ACCOUNTBLOCKED'].description);
  return (
    <Banner alertType='critical' className='fe_u_padding--small'>
      <BannerItem headerText={HEADER_TEXT}>
        {HEADER_DESCRIPTION}
      </BannerItem>
    </Banner>
  );
}
